export default "__VITE_ASSET__CbN7AwjX__"